import { Injectable } from "@angular/core";
import { UserCompanyService } from "./userCompany.service";
import { UserInterface, UserServiceAbstract } from "@mare-common/ngx-mare-user";
import { Subject } from "rxjs";
import { TokenService } from "./token.service";

declare const window: any;
  @Injectable({
    providedIn: 'root'
  })
  export class UserService extends UserServiceAbstract {
    retriveUserPromise: Promise<UserInterface | null> | null = null;

    user$: Subject<UserInterface> = new Subject<UserInterface>();

    constructor(
      protected userCompanyService: UserCompanyService,
      private tokenService: TokenService
    ) {
      super();
      this.init();
    }

    retrieveUser(forceReload?: boolean): Promise<UserInterface | null> {
      
      if(!forceReload && this.retriveUserPromise) {
        return this.retriveUserPromise;
      }
      this.retriveUserPromise = new Promise<UserInterface | null>((resolve, reject) => {
        if(this.user) {
          resolve(this.user);
          setTimeout(() => {
            this.retriveUserPromise = null;
          }, 50);
          return;
        }

        let loggedSub = this.tokenService.loggedSignal.subscribe((logged: boolean) => {
          if(logged) {
            this.userCompanyService.retrieveUserCompany(forceReload)
            .catch((err: any) => {
              reject(err);
              setTimeout(() => {
                this.retriveUserPromise = null;
              }, 50);
              return err;
            })
            .then((userCompany: any) => {
              if(!userCompany) {
                reject(null);
              } else {
                if(!window.ajax_msc_object) {
                  window.ajax_msc_object = {};
                }
                window.ajax_msc_object.currentUser = userCompany.user;
                resolve(userCompany.user);
                this.user$.next(userCompany.user);
              }
              setTimeout(() => {
                this.retriveUserPromise = null;
              }, 50);
            }).finally(() => {
              loggedSub.unsubscribe();
            });
          }
        })
      });
      return this.retriveUserPromise;
    }
    
  }